import React, { useCallback, useState, useRef, useEffect } from "react";
import commentContext from "../contextApi/index";

import ReComments from "../ReComments/index";
import TextAreaUpdate from "./CommentTextUpdate/index";
import CommentRenderTwo from "./CommentRenderTwo/index";

import { DetailLine } from "../../common/commonStyle";

import { CommentItem, Deleted, DeleteItem } from "./style";

function Comments({ post, comment }) {
  const commentRef = useRef(null);

  const [moreRecomments, setMoreRecomments] = useState(false); // 대댓글 전부로드
  const [commentMore, setCommentMore] = useState(false); // 댓글 더보기 토글 - 변수만context넘기기
  const [visible, setVisible] = useState(true);

  const setCommentMorePropsFunc = () => {
    setCommentMore((prev) => !prev);
  };
  const setVisiblePropsFunc = () => {
    setVisible((prev) => !prev);
  };

  // 삭제된 답글배열
  const deletedRecomArr = comment.recomment?.filter(
    (v) => v.isDeleted === "true",
  );

  const addNumber = Number(comment.recommentCount) + deletedRecomArr.length; //삭제된것도 포함된 총 답글수

  const recommentsFilterArray = comment.recomment?.filter((v, i) => i > 1);
  const onClickMoreReComments = useCallback(() => {
    return setMoreRecomments((prev) => !prev);
  }, []);

  // 댓글 렌더링
  return comment.isDeleted === "true" ? ( // 삭제된 댓글일 경우
    <Deleted>
      <DeleteItem>
        <img src="/img/deleteIcon.svg" alt="삭제표시 아이콘" />
        {comment.deleteByAdmin === "true" ? (
          <div>정책 위반으로 삭제된 댓글입니다.</div>
        ) : (
          <div>사용자가 삭제한 댓글입니다.</div>
        )}
      </DeleteItem>
      <DetailLine />

      {/* 답글부분 */}
      {addNumber > 0 && (
        <>
          {comment.recomment[0] && (
            <ReComments
              post={post}
              comment={comment}
              recomment={comment.recomment[0]}
            />
          )}
          {comment.recomment[1] && (
            <ReComments
              post={post}
              comment={comment}
              recomment={comment.recomment[1]}
            />
          )}
        </>
      )}

      {addNumber > 2 && (
        <>
          {moreRecomments &&
            recommentsFilterArray?.map((recomment) => (
              <ReComments
                key={recomment.recommentId}
                post={post}
                comment={comment}
                recomment={recomment}
              />
            ))}
          <div className="recommentsMore" onClick={onClickMoreReComments}>
            {moreRecomments ? (
              <span>닫기</span>
            ) : (
              <span>+ 답글 {addNumber - 2}개 더보기</span>
            )}
          </div>

          <DetailLine />
        </>
      )}
    </Deleted>
  ) : visible ? ( // 삭제되지 않은 댓글일 경우, 수정중이 아닐 때
    <commentContext.Provider
      value={{ commentMore, setVisiblePropsFunc, setCommentMorePropsFunc }}
    >
      <CommentItem className="comments" ref={commentRef}>
        <CommentRenderTwo post={post} comment={comment} render="comments" />

        <DetailLine />
        {addNumber > 0 && (
          <>
            {comment.recomment[0] && (
              <ReComments
                post={post}
                comment={comment}
                recomment={comment.recomment[0]}
              />
            )}
            {comment.recomment[1] && (
              <ReComments
                post={post}
                comment={comment}
                recomment={comment.recomment[1]}
              />
            )}
          </>
        )}

        {addNumber > 2 && (
          <>
            {moreRecomments &&
              recommentsFilterArray?.map((recomment) => (
                <ReComments
                  key={recomment.recommentId}
                  post={post}
                  comment={comment}
                  recomment={recomment}
                />
              ))}
            <div className="recommentsMore" onClick={onClickMoreReComments}>
              {moreRecomments ? (
                <span>닫기</span>
              ) : (
                <span>+ 답글 {addNumber - 2}개 더보기</span>
              )}
            </div>

            <DetailLine />
          </>
        )}

        {/* 신고됨 알림 */}
        {/* {commentAccusedToggle && <Accused />} */}
      </CommentItem>
    </commentContext.Provider>
  ) : (
    <TextAreaUpdate
      post={post}
      comment={comment}
      setCommentMorePropsFunc={setCommentMorePropsFunc}
      setVisiblePropsFunc={setVisiblePropsFunc}
    />
  );
}

export default Comments;
